import { render, staticRenderFns } from "./PowerGrammarFixLeft.vue?vue&type=template&id=fdb3f0fa&scoped=true"
import script from "./PowerGrammarFixLeft.vue?vue&type=script&lang=js"
export * from "./PowerGrammarFixLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb3f0fa",
  null
  
)

export default component.exports